import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_LOAN_PROGRAMS } from "@/redux/constants/parameters";

const getLoanPrograms = sharedService.injectEndpoints({
  endpoints: builder => ({
    getLoanPrograms: builder.query({
      query: () => "parameters/loan-programs",
      transformResponse: response => response.items,
      providesTags: ["LoanPrograms"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_LOAN_PROGRAMS, loanPrograms: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoanProgramsQuery } = getLoanPrograms;

